module.exports = __webpack_public_path__ + "images/fontawesome-webfont.svg";